import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponse } from '../../core/shared/classes/api';
import { ApiService } from '../../core/services/api.service';
import { Onglet } from '../classes/onglet';

@Injectable()
export class Z16ProOngletDefautService {

    constructor (
        private apiService: ApiService
    ) { }

    getOngletsDefautByEntite(entiteId: string): Observable<ApiResponse> {
        return this.apiService.get(`z16pro/onglets-defaut/entite/${entiteId}`);
    }

    saveOngletDefaut(onglets: any) {
        return this.apiService.post(`z16pro/onglets-defaut/entite/`, onglets);
    }

}
